import { useGetCompanyDetail } from "@/api/console/companies/useGetCompany";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import { handleCompanyName } from "@/lib/handleName";
import {
  CompanyUpdate,
  companyUpdateSchema,
} from "@/schema/console/companies/CompanyUpdate";
import CompanyForm from "@/src/console/(auth)/companies/[id]/edit/_components/CompanyForm";
import CompanyFormActionButtons from "@/src/console/(auth)/companies/[id]/edit/_components/CompanyFormActionButtons";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

function CompanyEdit() {
  const { t } = useTranslation();
  const { id = "" } = useParams();

  const { data } = useGetCompanyDetail(id);
  const company = data?.data;

  const breadcrumbs = [
    {
      name: t("companies"),
      href: "/console/companies",
    },
    {
      name: handleCompanyName(company?.id || 0, company?.company_name || ""),
      href: `/console/companies/${id}`,
    },
    {
      name: t("edit"),
      href: "/console/companies/edit",
    },
  ];

  const methods = useForm<CompanyUpdate>({
    resolver: zodResolver(companyUpdateSchema),
    values: company
      ? {
          industry_code: company.registration_number
            ? company.registration_number.slice(0, 2)
            : "",
          ...company,
        }
      : undefined,
  });

  return (
    <>
      <FormProvider {...methods}>
        <AdminNavbar breadcrumbs={breadcrumbs} />
        <CompanyForm />
        <CompanyFormActionButtons id={id} />
      </FormProvider>
    </>
  );
}

export default CompanyEdit;
